import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '@app/core/services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentTenant = this.authenticationService.currentTenant;
    
    if (currentTenant && currentTenant.tenantId) {
      request = request.clone({
        setHeaders: {
          '__tenant': currentTenant.tenantId
        }
      });
    }

    if (currentTenant && currentTenant.token) {
      request = request.clone({
        setHeaders: {
          'Authorization': currentTenant.token_type + ' ' + currentTenant.token
        }
      });
    }
    return next.handle(request);
  }
}
